/* External dependencies */
import { filter, Observable, switchMap } from 'rxjs';

/* Local dependencies */
import { setAuthenticatedClient } from '../../../../client/graphql';
import {
  ApproveDeviceActions,
  ApproveDeviceActionTypes,
  approveDeviceFailed,
  ApproveDeviceRequest,
  approveDeviceSucceeded,
} from './action';
import { approveDeviceQuery } from './approveDeviceQuery';

export function approveDeviceEpic(action$): Observable<ApproveDeviceActionTypes> {
  return action$.pipe(
    filter((action: ApproveDeviceActions) => action.type === ApproveDeviceActionTypes.APPROVE_DEVICE_REQUEST),
    switchMap((action: ApproveDeviceRequest) =>
      approveDevice(action.input).then(approveDeviceSucceeded).catch(approveDeviceFailed),
    ),
  );
}

export async function approveDevice(input) {
  const graphQLClient = await setAuthenticatedClient();
  try {
    const { data } = await graphQLClient.mutate({
      mutation: approveDeviceQuery,
      variables: { input },
    });
    console.log('✅ Response:', JSON.stringify(data, null, 2));
    return data.approveDevice;
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length > 0) {
      const errorType = e.graphQLErrors[0].errorType;
      throw new Error(errorType);
    }
    throw new Error('InternalServerError');
  }
}
